
<div class="row">
  <div class="stack">
    <h2 class="link blog-title" [class.remote]="!local()">
      @if (tagLink()) {
        <app-nav [url]="url()" [text]="title()" />
      } @else if (clickableLink()) {
        <app-nav [url]="url()" [text]="title()" [external]="true" />
      } @else {
        <span>{{ title() }}</span>
      }
    </h2>
    <div class="link-below">
      <div class="stack">
        <div class="info">
          @if (authors().length) {
            <ng-container i18n>
              by
              @if (authorExts.hasValue() ? authorExts.value() : undefined; as xs) {
                @for (x of xs; track x) {
                  <a class="user tag"
                     [title]="formatAuthor(x.tag + x.origin)"
                     [routerLink]="['/tag', x.tag + x.origin]"
                     [appTitle]="x">{{ x.name || formatAuthor(x.tag) }}</a>
                }
              } @else {
                @for (t of authors(); track t) {
                  <a class="user tag"
                     [title]="formatAuthor(t)"
                     [routerLink]="['/tag', t]">{{ formatAuthor(t) }}</a>
                }
              }
            </ng-container>
          }
          @if (tags().length) {
            <ng-container i18n>
              tagged
              @if (tagExts.hasValue() ? tagExts.value() : undefined; as xs) {
                @for (x of xs; track x) {
                  <a class="tag" [routerLink]="['/tag', x.tag]" [appTitle]="x.tag">{{ x.name || '#' + x.tag }}</a>
                }
              } @else {
                @for (t of tags(); track t) {
                  <a class="tag" [routerLink]="['/tag', t]">{{ t }}</a>
                }
              }
            </ng-container>
          }
          @for (icon of icons(); track icon) {
            @if (showIcon(icon)) {
              <span class="icon"
                    [class.filter-toggle]="icon.tag"
                    (click)="clickIcon(icon, store.hotkey())"
                    [appTitle]="icon"
                    [ref]="ref()">{{ icon.label }}</span>
            }
          }
          <span [title]="ref().published?.toISO()">{{ ref().published | relative }}</span>
          @if (!authors().length && ref().created && !local()) {
            <ng-container i18n>
              on <a class="origin tag" [routerLink]="['/tag', ref().origin]">{{ ref().origin }}</a>
            </ng-container>
          }
        </div>
        <div class="actions">
          <a [routerLink]="['/ref', ref().url]" [queryParams]="{ origin: nonLocalOrigin() }" (click)="saveRef()" i18n>permalink</a>
          @if (store.account.user) {
            <a class="fake-link" (click)="replying.set(!replying())" i18n>reply</a>
          }
          @if (comments()) {
            <a [routerLink]="['/ref', ref().url, 'comments']" [queryParams]="{ origin: nonLocalOrigin() }" (click)="saveRef()" i18n>{comments(), plural, =1 {1&thinsp;comment} other {{{ comments() }}&thinsp;comments}}</a>
          }
          @if (responses()) {
            <a [routerLink]="['/ref', ref().url, 'responses']" [queryParams]="{ origin: nonLocalOrigin() }" (click)="saveRef()" i18n>{responses(), plural, =1 {1&thinsp;citation} other {{{ responses() }}&thinsp;citations}}</a>
          }
          @if (sources() === 1) {
            <a [routerLink]="['/ref', ref().sources?.[0]]" [queryParams]="{ origin: nonLocalOrigin() }" i18n>parent</a>
          } @else if (sources() > 1) {
            <a [routerLink]="['/ref', ref().url, 'sources']" [queryParams]="{ origin: nonLocalOrigin() }" (click)="saveRef()" i18n>{{ sources() }}&thinsp;sources</a>
          }
          @if (store.account.mod || taggingAccess()) {
            <app-confirm-action
                                [class.force-delete]="deleteAccess()"
                                [action]="store.hotkey() ? forceDelete$ : delete$" i18n>delete</app-confirm-action>
          }
          @if (taggingAccess()) {
            <app-inline-tag [action]="tag$" [tags]="ref().tags" i18n>tag</app-inline-tag>
          }
          @if (writeAccess()) {
            <a class="fake-link" (click)="toggleEditing()" i18n>@if (draft()) {*edit*} @else {edit}</a>
          } @else {
            <a class="fake-link" (click)="toggleViewSource()" i18n>source</a>
          }
          @if (canInvoice()) {
            <a [routerLink]="['/submit/invoice']" [queryParams]="{url: ref().url}" i18n>invoice</a>
          }
          <app-action-list [ref]="ref()"
                           [repostRef]="repostRef()"
                           [groupedActions]="groupedActions()" />
        </div>
      </div>
    </div>
  </div>
</div>
@if (replying()) {
  <app-comment-reply #reply
                     [autofocus]="true"
                     [to]="ref()"
                     [showCancel]="true"
                     [tags]="replyTags()"
                     (save)="goToComments()" />
}
@if (editing()) {
  <form class="form" [formGroup]="editForm" (ngSubmit)="save()">

    <app-ref-form [group]="editForm" [ref]="ref()" />

    @for (e of serverError(); track e) {
      <span><!-- Unexpected Error --></span>
      <div class="error">{{ e }}</div>
    }

    <span><!-- Buttons --></span>
    <span class="buttons right floating">
      @if (submitting()) {
        <app-loading [inline]="true" />
      }
      <button type="submit" [disabled]="submitting() || submitted() && !editFormValid()" i18n>save</button>
      <button class="blog-edit-cancel" type="button" [disabled]="submitting()" (click)="cancelEdit()" i18n>cancel</button>
    </span>
  </form>
} @else if (viewSource()) {
  <form class="form" [formGroup]="editForm">
    <app-ref-form [group]="editForm" [ref]="ref()" [origin]="ref().origin" />
  </form>
} @else {
  <app-viewer class="blog-body" [ref]="ref()" />
  @for (e of serverError(); track e) {
    <div class="error">{{ e }}</div>
  }
}

<h5 [routerLink]="['/ref', ref().url, 'comments']" [queryParams]="{ origin: nonLocalOrigin() }" i18n>Comments:</h5>
<div class="summary-box" [class.hidden-without-removing]="!comments()">
  <app-thread-summary query="plugin/comment:!plugin/delete"
                      [commentView]="true"
                      [showLoadMore]="false"
                      [source]="ref().url"
                      [depth]="1"
                      [pageSize]="summaryItems" />
  <a class="load-more" [routerLink]="['/ref', ref().url, 'comments']" [queryParams]="{ origin: nonLocalOrigin() }" i18n>
    more comments
  </a>
</div>
<app-comment-reply [to]="ref()"
                   [tags]="replyTags()"
                   (save)="goToComments()" />
<hr>
